import { Cancel, Check, Edit } from "@mui/icons-material";
import { Button, CircularProgress, IconButton, TextField } from "@mui/material";
import { useState } from "react";
import MKSpesialService from "../../../../services/Integration/mkspesial/MKSpesialService";
import SimpleAlert from "../../../../components/common/SimpleAlert/SimpleAlert";

const JudulKarya = ({ mKSpesial, refreshMKSpesial }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [judul, setJudul] = useState("");
  const [isError, setIsError] = useState(false);

  const handleJudulInputChange = (newJudul) => setJudul(newJudul);

  const handleSubmit = async () => {
    setIsLoading(true);
    const mkSpesial = { ...mKSpesial, judul: judul };
    await MKSpesialService.updateMKSpesial(mkSpesial)
      .then((response) => {
        if (response.status === 200) {
          refreshMKSpesial();
        } else {
          setIsError(true);
          console.log(response);
        }
      })
      .catch((error) => {
        setIsError(true);
        console.log(error);
      });
    setIsLoading(false);
  };

  return (
    <div>
      {isEdit ? (
        <div className="flex flex-row">
          <TextField
            value={judul}
            onChange={(e) => handleJudulInputChange(e.target.value)}
            required
            variant="standard"
            inputProps={{ style: { fontSize: "1.5rem", fontWeight: "bold" } }}
            fullWidth
            multiline
          />
          <IconButton onClick={handleSubmit} LinkComponent={"button"}>
            {isLoading ? <CircularProgress size={"20px"} /> : <Check />}
          </IconButton>
          <IconButton onClick={() => setIsEdit(!isEdit)}>
            <Cancel />
          </IconButton>
        </div>
      ) : (
        <div className="flex flex-row items-center">
          <div className="text-2xl font-bold">
            {mKSpesial.judul ?? "Judul Placeholder"}
          </div>
          <div>
            <IconButton
              onClick={() => {
                setJudul(mKSpesial.judul);
                setIsEdit(!isEdit);
              }}
              LinkComponent={"button"}
            >
              <Edit />
            </IconButton>
          </div>
        </div>
      )}
      <SimpleAlert
        open={isError}
        onClose={() => setIsError(false)}
        dialogTitle={"Error"}
        dialogMessage={`Gagal memproses Judul MK Spesial. Cobalah beberapa saat lagi atau hubungi admin SISIDANG`}
        dialogActions={
          <>
            <Button variant="contained" onClick={() => setIsError(false)}>
              Ok
            </Button>
          </>
        }
      />
    </div>
  );
};

export { JudulKarya };
